module.exports = __webpack_public_path__ + "media/images/front/programs/icon-sort-inactive-00af59091a4d908de8fb3add5ef42d9d.svg";